import { GroupSecurity } from '@quromedical/fhir-common';
import { withPermissions } from 'components/groups';
import { MediaListScreen } from 'screens/patient';

export default withPermissions(MediaListScreen, [GroupSecurity.MediaRead]);
